import React from "react";
import CustomButton from "../../components/customButton";

const UIError = ({ history }) => {
  return (
    <section
      className="error-main-container ui-error"
      data-testid="error-page-wrapper"
    >
      <article className="error-content">
        <h2 className="status">Oops!</h2>
        <h3 className="access">There has been an error</h3>
        <p className="message">
          We&apos;re sorry to inform that the application has encountered an
          error.
          <br />
          We are trying to fix it.
        </p>
        <div className="action-btn" data-testid="error-page-button">
          <CustomButton
            type="primary"
            title="Go Back"
            onClick={() => history.goBack()}
          />
        </div>
      </article>
    </section>
  );
};
export default UIError;
